import { TripMode } from '@/types/webapi';
import { isNumber, isUndefined } from 'lodash-es';

/**
 * Determines if the tripMode is a transit type.
 * @param tripMode TripMode value
 * @returns True if input is transit type, false otherwise.
 */
export function isTransitMode(tripMode?: TripMode) {
    return isNumber(tripMode) && !isUndefined(TripMode[tripMode]) && tripMode !== TripMode.Foot && tripMode !== TripMode.Bicycle;
}
